import axiosInstance from "./axiosInstance";

const endpoint = "/testmenu";

// get agency list
export const testmenuAgencyList = async () => {
  try {
    const response = await axiosInstance.get(`${endpoint}/agency/list`, {});
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    throw error;
  }
};

// create new agency
export const testmenuCreateAgency = async (agencyData) => {
  try {
    const response = await axiosInstance.post(`${endpoint}`, agencyData);
    return response.data;
  } catch (error) {
    console.error("Error create new agency :", error);
    throw error;
  }
};

// get agency by id
export const testmenuGetAgency = async (id) => {
  try {
    const response = await axiosInstance.get(`${endpoint}/agency/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching agency by id:", error);
    throw error;
  }
};

// update agency by id
export const testmenuUpdateAgency = async (id, agencyData) => {
  try {
    const response = await axiosInstance.put(`${endpoint}/agency/${id}`, agencyData);
    return response.data;
  } catch (error) {
    console.error("Error update agency :", error);
    throw error;
  }
};

// delete agency by id
export const testmenuDeleteAgency = async (id) => {
  try {
    const response = await axiosInstance.delete(`${endpoint}/agency/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error delete agency :", error);
    throw error;
  }
};